import dayjs from 'dayjs';
import IconCallMe from 'assets/images/svg/button-help/call-me.svg';
import IconHelpChat from 'assets/images/svg/button-help/chat.svg';
import IconClose from 'assets/images/svg/button-help/close-help.svg';
import IconWhatsapp from 'assets/images/svg/button-help/icon-whatssap.svg';
import IconTelephone from 'assets/images/svg/button-help/telephone.svg';
import IconMain from 'assets/images/svg/button-help/icon-main.svg';
import useOnClickOutside from 'libs/hooks/useOnClickOutside';
import React, { useRef, useState, useContext } from 'react';
import { AppContext } from 'domains/commons/contexts/global/global-provider';
import { usePatchPhaseOpportunity } from 'domains/core-base/crm-oracle/hooks/mutation/use-patch-phase-opportunity';

import './button-help.scss';
import { useLocation } from 'react-router-dom';
import { DataLayer } from 'libs/providers/datalayer/datalayer';
import { globalFlow } from 'libs/providers/datalayer/constants';
import { CrmPhase } from 'domains/landing-autos/enums/crm.enum';
import { usePatchEnqueueOpportunity } from 'domains/core-base/crm-oracle/hooks/mutation/use-patch-enqueue-opportunity';
import { formatDate } from 'domains/new-quotation/utils/format-date';
import { isEnableEnqueuePCCA } from 'libs/constants/validation-env';

export type IButtonHelpProps = {
  pageLanding?: boolean;
};

const ButtonHelp: React.FC<IButtonHelpProps> = (props) => {
  const route = useLocation();
  const page = route.pathname.replace(/\//, '');

  const [isActive, setIsActive] = useState(false);
  const handleClick = () => {
    if (!isActive) {
      DataLayer.setVirtualEvent({
        category: 'Seguro Vehicular',
        action: page,
        label: `Clic - Enlace - Necesitas Ayuda`,
        flujo: '',
      });
    }

    setIsActive(!isActive);
  };
  const handleClose = () => setIsActive(false);
  const buttonRef = useRef(null);
  const contactRef = useRef(null);

  useOnClickOutside(buttonRef, handleClose);
  useOnClickOutside(contactRef, handleClose);
  const { store } = useContext(AppContext);
  const { dataLayer } = store;
  const oracleOfferUpdate = usePatchPhaseOpportunity();
  const oracleEnqueueUpdate = usePatchEnqueueOpportunity();

  const onClickToCall = () => {
    try {
      DataLayer.setVirtualEvent({
        category: 'Seguro Vehicular',
        action: page,
        label: `Clic - Enlace - Llamada`,
        flujo: '',
      });

      const requestData = {
        data: {
          chECFase_c: CrmPhase.quotation,
          cECSumaAsegurada_c: store.vehicle.sumInsured?.estimated,
          dECCotizacion_c: formatDate(),
          tEnrConclusion_c: globalFlow(dataLayer),
        }
      }

      oracleOfferUpdate.mutateAsync({
        ...requestData,
        options: {
          optyNumber: store.oracle.optyNumber,
        },
      });
      if(isEnableEnqueuePCCA){
        oracleEnqueueUpdate.mutate({
          data: {
            ...requestData.data,
            identificadorCliente: `${store.customer?.id ?? ''}`,
            identificadorSolicitud: store.request?.id,
            identificadorVehiculo: store.vehicle?.id ?? '',
          },
          options: {
            optyNumber: store.oracle.enqueueOptyNumber,
          },
        })
      }
    } catch {
      // eslint-disable-next-line no-console
      console.error('@oracle-crm/fase: oferta');
    }
  };

  return (
    <>
      {props.pageLanding ? (
        <div className="content-help" data-testid="button-help">
          <button
            className={`content-help__icon ${isActive && 'active-content'}`}
            onClick={handleClick}
            data-testid="toggle"
            ref={buttonRef}
            type="button"
          >
            <img
              src={isActive ? IconClose : IconHelpChat}
              alt="icon-hel-center"
              className="icon-help"
            />
          </button>
          <div className={`content-help__circle ${isActive && 'is-active'} `}>
            <a
              className="fab-action fab-action-1"
              href="tel:015135025"
              onClick={onClickToCall}
            >
              <img src={IconCallMe} alt="icon" />
              <p className="fab-action__text">Llámanos y te ayudamos</p>
            </a>
            <a
              className="fab-action fab-action-2"
              href="https://api.whatsapp.com/send/?phone=51994151515"
              target="_blank"
              rel="noopener noreferrer"
              role="button"
              aria-label="Button WhatsApp"
            >
              <img src={IconWhatsapp} alt="icon-whatsapp" />
              <p className="fab-action__text">Conversamos por WhatsApp</p>
            </a>
          </div>
        </div>
      ) : (
        <div>
          <button
            type="button"
            className="content-help-quote"
            onClick={handleClick}
            ref={contactRef}
          >
            <h3 className="content-help-quote__title">¿Necesitas ayuda?</h3>
            <span>
              <img
                src={IconMain}
                alt="help-quote"
                className="content-help-quote__icon"
              />
            </span>
            <div className={`content-help-quote__card ${isActive && 'active'}`}>
              <img src={IconTelephone} alt="telephone" />
              <a
                className="content-help-quote__card-title"
                href="tel:015135000,3"
                onClick={onClickToCall}
              >
                <p className="subtitle">Te ayudamos con tu compra</p>
                (01) 513-5000 Opción 3
              </a>
            </div>
          </button>
        </div>
      )}
    </>
  );
};


export default ButtonHelp;
